import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { PaginationParams } from '@core/api/api-entity.service';
import { DdqGpInvitation, DdqInviteeRow, DdqLpInvitation } from '@core/models/ddq-invitation.model';

export interface DdqInvitationState {
  gpInvitations: DdqGpInvitation[];
  lpInvitations: DdqLpInvitation[];
  inviteeRows: DdqInviteeRow[];
  gpPagination: PaginationParams | null;
  lpPagination: PaginationParams | null;
  inviteePagination: PaginationParams | null;
  loading: boolean;
  error: string | null;
  /** null = not yet loaded; used for sidebar Invitees visibility. */
  hasInvitees: boolean | null;
}

function createInitialState(): DdqInvitationState {
  return {
    gpInvitations: [],
    lpInvitations: [],
    inviteeRows: [],
    gpPagination: null,
    lpPagination: null,
    inviteePagination: null,
    loading: false,
    error: null,
    hasInvitees: null,
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'ddqInvitations', resettable: true })
export class DdqInvitationStore extends Store<DdqInvitationState> {
  constructor() {
    super(createInitialState());
  }

  setGpInvitations(invitations: DdqGpInvitation[], pagination?: PaginationParams | null): void {
    this.update({
      gpInvitations: invitations,
      gpPagination: pagination ?? null,
      loading: false,
      error: null,
    });
  }

  setLpInvitations(invitations: DdqLpInvitation[], pagination?: PaginationParams | null): void {
    this.update({
      lpInvitations: invitations,
      lpPagination: pagination ?? null,
      loading: false,
      error: null,
    });
  }

  setInviteeRows(rows: DdqInviteeRow[], pagination?: PaginationParams | null): void {
    this.update({
      inviteeRows: rows,
      inviteePagination: pagination ?? null,
      loading: false,
      error: null,
    });
  }

  setHasInvitees(hasInvitees: boolean): void {
    this.update({ hasInvitees });
  }

  setLoading(loading: boolean): void {
    this.update({ loading });
  }

  setErrorState(error: string | null): void {
    this.update({ error, loading: false });
  }
}
